import GroupForm from './components/GroupForm';

const GroupNewPage = () => {
  return (
    <div className="flex flex-col gap-4">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">Nuevo grupo</h1>
        <p className="text-sm text-slate-500">
          Configurá el dispenser y la bolsa principal del grupo.
        </p>
      </div>
      <GroupForm />
    </div>
  );
};

export default GroupNewPage;
